import { Store } from 'app/model';
import { HistoryResponse } from 'app/model/history-response';

import { RestfulApiService } from '../restful-api.service';

export class StoreHistoryService extends RestfulApiService<HistoryResponse, Store> {
    protected getFormName(): string {
        throw new Error('Method not implemented.');
    }
    protected getPath(parent: Store): string {
        return `stores/${parent.id}/attrs/history`;
    }
}
export const storeHistoryService = new StoreHistoryService();
